import {orderBy} from './orderBy';
import { LibraryItem } from '../entities/LibraryItem';
import { printLibraryItemType } from '../entities/LibraryItemType';
import { printAssetCategory } from '../entities/AssetCategory';
import { SortCatagories } from '../pages/Library/Views/Components/SortByDropDown';

export function LibraryItemSort(sortBy:SortCatagories,items:LibraryItem[], direction:"Ascending"|"Descending") {

    const dateDirection = direction === "Ascending" ? "Descending" : "Ascending";

    switch(sortBy){
        case ('Name'):
            return items.sort(orderBy.string((i) => i.name, direction));
        case ('Type'):
            return items.sort(orderBy.string((i) => i.category ? printAssetCategory(i.category) : printLibraryItemType(i.type) , direction));
        case ('Created Date'):
            return items.sort(orderBy.date((i) => i.dateCreated, dateDirection));
        case ('Last Modified'):
            return items.sort(orderBy.date((i) => i.dateModified, dateDirection));
        case ('Last Opened'):
            return items.sort(orderBy.date((i) => i.dateAccessed, dateDirection));
        case ('Preach Date'):
            let itemsNoPreachdate = items.filter(i => !i.datePreached);
            let ItemsWithPreachDate = items.filter(i => i.datePreached);
            return ItemsWithPreachDate.sort(orderBy.date((i) => i.datePreached!, dateDirection)).concat(itemsNoPreachdate);
        case ('Location'):
            let itemsNoLocation = items.filter(i => !i.locationPreached);
            let ItemsWithLocation = items.filter(i => i.locationPreached);
            return ItemsWithLocation.sort(orderBy.string((i) => i.locationPreached!, direction)).concat(itemsNoLocation);
        default:
            return items;
    }
};